<template>
  <BoardView :title="prompt.name">
    <FormValidation @submit="save">
      <FormPrompt :prompt="prompt" />
      <Btn class="info" :isLoading="isSaving" type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import BoardSingle from '@mixins/BoardSingle'
import FormPrompt from '@forms/FormPrompt'

export default {
  mixins: [BoardSingle('prompt')],
  components: { FormPrompt },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "submit": "Update"
  }
}
</i18n>
